var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcInvalidNamePurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#6728FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30 40c1.372 0 2.661-.262 3.868-.787 1.207-.525 2.27-1.247 3.19-2.166.919-.919 1.639-1.98 2.16-3.184C39.74 32.66 40 31.372 40 30c0-1.372-.26-2.66-.782-3.863-.521-1.204-1.243-2.267-2.166-3.19-.922-.922-1.987-1.644-3.194-2.165C32.651 20.26 31.361 20 29.99 20c-1.358 0-2.64.26-3.848.782-1.207.521-2.272 1.243-3.194 2.166-.923.922-1.645 1.985-2.166 3.189C20.26 27.34 20 28.628 20 30c0 1.372.262 2.66.787 3.863.525 1.204 1.247 2.265 2.166 3.184.919.92 1.982 1.641 3.189 2.166 1.207.525 2.493.787 3.858.787zm0-8.272c-.562 0-.85-.284-.864-.854l-.134-5.061c-.014-.275.072-.503.257-.684.185-.182.429-.273.73-.273.296 0 .536.09.72.273.186.181.279.413.279.694l-.144 5.051c-.014.57-.295.854-.844.854zm0 3.323c-.316 0-.586-.104-.813-.313-.226-.21-.34-.465-.34-.767 0-.308.114-.567.34-.777.227-.209.497-.313.813-.313.316 0 .586.104.813.313.226.21.34.469.34.777 0 .309-.116.566-.345.772-.23.206-.5.308-.808.308z",
    transform: "translate(-37.000000, -792.000000) translate(17.000000, 772.000000)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInvalidNamePurple);
export default __webpack_public_path__ + "static/media/ic_invalid_name_purple.0b577db7066f0d63e29ce40b094cb74f.svg";
export { ForwardRef as ReactComponent };